import { Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fmtDate } from "@/lib/format";

export const TrialBanner = ({ company, isAdmin = true }) => {
  if (!company || company.plan !== "trial" || company.trial_expired) return null;
  const left = company.trial_days_left;
  const urgent = left <= 3;
  return (
    <div className={`text-xs sm:text-sm px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 ${urgent ? "bg-red-600 text-white" : "bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-200"}`} data-testid="trial-banner">
      <span className="flex items-center gap-1.5 font-semibold"><Clock className="w-4 h-4" /> Versione di prova gratuita</span>
      <span data-testid="trial-days-left">
        {left <= 1 ? "Scade oggi" : `${left} giorni rimasti`} · scade il {fmtDate(company.trial_ends_at)}
      </span>
      {isAdmin && <Link to="/abbonamento" className="underline font-semibold flex items-center gap-1" data-testid="trial-banner-continue">
        Continua <ArrowRight className="w-3.5 h-3.5" />
      </Link>}
    </div>
  );
};

export default TrialBanner;
